export class ModalConfirm {
    constructor(mcBodyTemplate = null) {
        if (mcBodyTemplate == null)
            mcBodyTemplate = $("#template-modalConfirm");
        //
        this.id = "Modal_" + (new Date()).getTime();
        this.mc = mcBodyTemplate.clone();
        this.mc.attr("id", this.id);
        //
        this.bClosed = false;
        this.callBack = null;
    }
    /*
     * title: "DELETE CONFIRM",
                body: "Are you sure you want to permanently remove this item? You can't undo this action.",
                yes: "YES",
                no: "NO",
                danger:true // viene il pulasnte rosso, altrimenti blue
    */
    create(options, callBack) {
        this.callBack = callBack;
        //
        $(".js-title", this.mc).html(options.title);
        $(".js-body", this.mc).html(options.body);
        $(".js-buttonModalYes", this.mc).text(options.yes);
        $(".js-buttonModalNo", this.mc).text(options.no);
        //
        $(".js-buttonModalYes", this.mc).on("click", this.onWindowClose.bind(this, true, true));
        $(".js-buttonModalNo", this.mc).on("click", this.onWindowClose.bind(this, false, true));
        $(".js-close", this.mc).on("click", this.onWindowClose.bind(this, false, true));
        //
        if (options.danger) {
            $(".js-buttonModalYes.primary", this.mc).hide();
        } else {
            $(".js-buttonModalYes.destructive", this.mc).hide();
        }
        //
        $("body").append(this.mc);
    }

    init() {
        // NOTHING TO DO
    }


    onWindowClose(confirm, toClose) {
        if (!this.bClosed) {
            this.bClosed = true;
            this.mc.remove();
            if (this.callBack)
                this.callBack(confirm)
        }
    }

}

// ************************************ //


export class ModalAlert {
    constructor(mcBodyTemplate) {
        if (mcBodyTemplate == null)
            mcBodyTemplate = $("#template-modalAlert");
        //
        this.id = "Modal_" + (new Date()).getTime();
        this.mc = mcBodyTemplate.clone();
        this.mc.attr("id", this.id);
        //
        this.bClosed = false;
        this.callBack = null;
    }

    /*
     * title: "DELETE CONFIRM",
                body: "Are you sure you want to permanently remove this item? You can't undo this action.",
                close: "YES",
                error:true // viene il pulasnte rosso, altrimenti blue
    */

    create(options, callBack) {
        this.callBack = callBack;
        //
        $(".js-title", this.mc).html(options.title);
        $(".js-body", this.mc).html(options.body);
        !options.hasList ? $(".js-buttonModalYes", this.mc).hide() : $(".js-buttonModalYes", this.mc).show();
        $(".js-buttonModalYes", this.mc).text(options.backToList);
        $(".js-buttonModalNo", this.mc).text(options.close);
        //
        $(".js-buttonModalNo", this.mc).on("click", this.onWindowClose.bind(this, false, true));
        $(".js-buttonModalYes", this.mc).on("click", this.onBackToList.bind(this, options.listUrl));
        $(".js-close", this.mc).on("click", this.onWindowClose.bind(this, false, true));
        //
        $(".modal-body", this.mc).removeClass("alert-modal");
        $(".modal-body", this.mc).removeClass("confirm-modal");

        if (options.error) {
            $(".modal-body", this.mc).addClass("alert-modal");
        } else {
            $(".modal-body", this.mc).addClass("confirm-modal");
        }
        //
        $("body").append(this.mc);
    }
    init() {
        // NOTHING TO DO
    }

    onResize() {
        if (!this.bClosed) {
            this.swidget.center();
        }
    }

    onWindowClose(confirm, toClose) {
        if (!this.bClosed) {
            this.bClosed = true;
            this.mc.remove();
            if (this.callBack)
                this.callBack(confirm)
        }
    }

    onBackToList(url) {
        window.location.href = url;
    }
}